import React, { useContext } from 'react';
import ContentBox from 'Components/common/ContentBox/ContentBox';
import { AppContext } from 'App.context';
import JoditEditor from 'jodit-react';
import SaveButton from 'Components/common/SaveButton/SaveButton';
import styles from '../DefaultInfoTexts.styles';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
import { EyeFilled } from '@ant-design/icons';
import sanitizeHtml from 'utils/sanitizeHtml';

export default function LegalDocumentsText({ state, actions }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const config = {
    placeholder: '',
    height: 300,
    toolbarAdaptive: false,
    removeButtons: ['fullsize', 'print', 'dots', 'copyformat', 'image'],
    showCharsCounter: false,
    showWordsCounter: false,
    cleanHTML: { fillEmptyParagraph: false },
  };

  return (
    <>
      <ContentBox noPadding title={translate('informationTexts.legalDocumentsInfo')}>
        <JoditEditor
          value={state.legalDocumentsText || ''}
          config={config}
          onBlur={val => actions.handleEditorChange(val, 'legalDocumentsText')}
        />
        <div style={styles.previewButton}>
          <AppButton
            secondary
            //action={} no action needed
            text={translate('legalDocuments.previewBtn')}
            icon={<EyeFilled style={{ color: '#708393' }} />}
            style={{
              alignSelf: 'flex-end',
            }}
          />
        </div>
        <div style={styles.saveButtonContainer}>
          <SaveButton
            action={applyToAll =>
              actions.onSavePressed('sign-info', state.legalDocumentsText, applyToAll)
            }
            text={translate('save')}
          />
        </div>
      </ContentBox>

      <ContentBox noPadding title={translate('legalDocuments.preview')}>
        <div style={styles.contentWrapper}>
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(state.legalDocumentsText) }} />
          <div style={styles.sectionBox}>
            <strong>{translate('legalDocuments.legalTexts.contract')}</strong>
            <button style={styles.sectionButton}>
              {translate('legalDocuments.legalTexts.viewContract')}
            </button>
          </div>
          <div style={styles.sectionBox}>
            <strong>{translate('legalDocuments.legalTexts.entranceRegistration')}</strong>
            <button style={styles.sectionButton}>
              {translate('legalDocuments.legalTexts.viewEntranceRegistration')}
            </button>
          </div>
          <div style={styles.signatureContainer}>
            <label style={styles.signatureLabel}>{translate('legalDocuments.contractSign')}</label>
            <div style={styles.signatureBox}></div>
          </div>
          <div style={styles.disabledButton}>{translate('legalDocuments.sign')}</div>
        </div>
      </ContentBox>
    </>
  );
}
